
// const themeConfig = {
// 	app: {
// 		appName: 'PMO Saúde',
// 		appUrl: 'http://localhost:3000',
// 		appDeveloper: 'Innovoweb Soluções Digitais',
// 		appDeveloperUrl: 'https://innovoweb.com.br'
// 	},
// 	api: {
// 		appUrl: 'http://localhost:3001/api/'
// 	},
// 	frontend: {
// 		appUrl: 'http://localhost:3001/'
// 	}
// }

const themeConfig = {
	app: {
		appName: 'PMO Saúde',
		appUrl: 'https://pmosaude.innovoweb.com.br/',
		appVersion: '1.0.0',
		appDeveloper: 'Innovoweb Soluções Digitais',
		appDeveloperUrl: 'https://innovoweb.com.br'
	},
	api: {
		appUrl: 'https://pmosaude.innovoweb.com.br/api/'
	},
	frontend: {
		appUrl: 'https://pmosaude.innovoweb.com.br/'
	}
}

export default themeConfig